'use es6';

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { OLAF } from 'HubStyleTokens/colors';
import { OperationPropType } from '../../../lib/api-explorer/models/Oas';
import parametersToJsonSchema from '../../../lib/api-explorer/parameters-to-json-schema';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import ParamForm from '../../ParamForm/components/ParamForm';
import UIButton from 'UIComponents/button/UIButton';
import PropertyCollapser from '../utils/PropertyCollapser';
import LazyLoadWrapper from '../../Response/components/LazyLoadWrapper';
import cloneDeep from 'hs-lodash/cloneDeep';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_PARAMS = 3;
const ParamsWrapper = styled.div.withConfig({
  displayName: "Params__ParamsWrapper",
  componentId: "sc-1vcd73e-0"
})(["background-color:", ";"], OLAF);
export default class Params extends Component {
  constructor(props) {
    super(props);

    // Collapsed/full schemas are cached and reused
    this.state = {
      isCollapsed: true,
      jsonSchema: null,
      isCalculated: false
    };
    this.onCollapseButtonClick = () => {
      // Capture scroll position so it can be restored after the
      // full schema has rendered
      if (this.state.isCollapsed) {
        this.startingScrollPosition = window.pageYOffset;
      }
      this.calculateSchemas(!this.state.isCollapsed);
      this.setState({
        isCollapsed: !this.state.isCollapsed,
        isCalculated: true
      });
    };
    this.calculateSchemas = (overrideIsCollapsed = null) => {
      const isCollapsed = overrideIsCollapsed !== null ? overrideIsCollapsed : this.state.isCollapsed;
      const {
        formData,
        oas,
        operation
      } = this.props;
      if (isCollapsed) {
        const full = this.fullSchema || parametersToJsonSchema(operation, oas);
        this.fullSchema = full;

        // Deep copy full schema to avoid clobbering it
        if (full) {
          this.setState({
            jsonSchema: this.collapser.collapsedSchema || this.collapser.calculateCollapsedSchema(cloneDeep(full), formData, operation),
            isCalculated: true
          });
        }
      } else {
        const schema = this.fullSchema || parametersToJsonSchema(operation, oas);
        this.fullSchema = schema;
        this.setState({
          jsonSchema: schema,
          isCalculated: true
        });
      }
    };
    this.renderContent = () => {
      const {
        formData,
        onChange,
        operation,
        usageTracker
      } = this.props;
      const {
        isCollapsed,
        jsonSchema,
        isCalculated
      } = this.state;
      if ((!jsonSchema || !jsonSchema.length) && isCalculated) {
        return /*#__PURE__*/_jsx("div", {
          className: "no-params",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.params.body.noParams"
          })
        });
      }
      return /*#__PURE__*/_jsx(LazyLoadWrapper, {
        mountOnce: true,
        onIntersect: this.calculateSchemas,
        children: /*#__PURE__*/_jsxs("div", {
          children: [isCalculated && /*#__PURE__*/_jsx("div", {
            className: "params-block",
            children: jsonSchema.map(schema => /*#__PURE__*/_jsx(ParamForm, {
              formData: formData[schema.type],
              id: `form-${operation.operationId}`,
              idPrefix: operation.operationId,
              onChange: form => onChange({
                [schema.type]: form.formData
              }),
              schema: schema.schema,
              schemaGroup: schema.label,
              usageTracker: usageTracker
            }, `${schema.type}-form`))
          }), isCalculated && this.collapser.collapseCount > 0 && /*#__PURE__*/_jsx(UIButton, {
            use: "tertiary",
            size: "extra-small",
            className: "m-top-2",
            onClick: this.onCollapseButtonClick,
            "data-test-id": isCollapsed ? 'expand-body-params' : 'collapse-body-params',
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: isCollapsed ? 'developer-docs-shared-components.params.body.expandButton' : 'developer-docs-shared-components.params.body.collapseButton'
            })
          })]
        })
      });
    };
    this.fullSchema = null;
    this.collapser = new PropertyCollapser(MAX_PARAMS);
    this.startingScrollPosition = null;
  }
  componentDidUpdate() {
    if (this.startingScrollPosition !== null) {
      window.scrollTo(0, this.startingScrollPosition);
      this.startingScrollPosition = null;
    }
  }

  /**
   * calculates both collapsed and full schema depending on state.isCollapsed
   * @param {Boolean} overrideIsCollapsed optionally override state.isCollapsed
   */

  render() {
    return /*#__PURE__*/_jsxs(ParamsWrapper, {
      className: "params",
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.params.header.parameters"
        })
      }), this.renderContent()]
    });
  }
}
Params.propTypes = {
  formData: PropTypes.object.isRequired,
  oas: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  operation: OperationPropType.isRequired,
  usageTracker: PropTypes.object.isRequired
};